// Utilitário para gerenciar localStorage de forma consistente
export const storage = {
  // Filtros da listagem de Individual
  getIndividualFilters: () => {
    try {
      const filters = localStorage.getItem('individual_filters');
      return filters ? JSON.parse(filters) : {
        txtNameSocialId: '',
        txtEmail: '',
        txtMobile: ''
      };
    } catch {
      return {
        txtNameSocialId: '',
        txtEmail: '',
        txtMobile: ''
      };
    }
  },

  setIndividualFilters: (filters: {
    txtNameSocialId: string;
    txtEmail: string;
    txtMobile: string;
  }) => {
    try {
      localStorage.setItem('individual_filters', JSON.stringify(filters));
    } catch (error) {
      console.warn('Failed to save filters:', error);
    }
  },

  // Ordenação e paginação da listagem
  getIndividualListState: () => {
    try {
      const state = localStorage.getItem('individual_list_state');
      return state ? JSON.parse(state) : {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    } catch {
      return {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    }
  },

  setIndividualListState: (state: {
    page: number;
    pageSize: number;
    field: string;
    order: 'ASC' | 'DESC';
  }) => {
    try {
      localStorage.setItem('individual_list_state', JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save list state:', error);
    }
  },

  // Legal Person list state
  getLegalPersonListState: () => {
    try {
      const state = localStorage.getItem('legal_person_list_state');
      return state ? JSON.parse(state) : {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    } catch {
      return {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    }
  },

  setLegalPersonListState: (state: {
    page: number;
    pageSize: number;
    field: string;
    order: 'ASC' | 'DESC';
  }) => {
    try {
      localStorage.setItem('legal_person_list_state', JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save list state:', error);
    }
  },

  // Legal Person filters
  getLegalPersonFilters: () => {
    try {
      const filters = localStorage.getItem('legal_person_filters');
      return filters ? JSON.parse(filters) : {
        txtPartnerName: '',
        txtGovTaxId: ''
      };
    } catch {
      return {
        txtPartnerName: '',
        txtGovTaxId: ''
      };
    }
  },

  setLegalPersonFilters: (filters: {
    txtPartnerName: string;
    txtGovTaxId: string;
  }) => {
    try {
      localStorage.setItem('legal_person_filters', JSON.stringify(filters));
    } catch (error) {
      console.warn('Failed to save filters:', error);
    }
  },

  // Após criar uma PJ: listagem sem filtro, id DESC, página 0 (AF-3977)
  resetLegalPersonListToNewest: (): string => {
    const { pageSize } = storage.getLegalPersonListState();
    storage.setLegalPersonFilters({ txtPartnerName: '', txtGovTaxId: '' });
    storage.setLegalPersonListState({ page: 0, pageSize, field: 'id', order: 'DESC' });
    return `/person/partners/0/${pageSize}/id/DESC/p=;r=;`;
  },

  // Limpar dados ao fazer logout
  clearAll: () => {
    try {
      localStorage.removeItem('individual_filters');
      localStorage.removeItem('individual_list_state');
      localStorage.removeItem('legal_person_filters');
      localStorage.removeItem('legal_person_list_state');
      localStorage.removeItem('authToken');
    } catch (error) {
      console.warn('Failed to clear storage:', error);
    }
  }
};
